var Accessibility;
(function (Accessibility) {
    __once('', () => {
        const carouselCardsWrapperNode = document.querySelector('.paragraph--type--carousel.paragraph--view-mode--default');
        const carouselCardsNodes = carouselCardsWrapperNode === null || carouselCardsWrapperNode === void 0 ? void 0 : carouselCardsWrapperNode.querySelectorAll('.paragraph--type--card');
        const checkboxNodes = document === null || document === void 0 ? void 0 : document.querySelectorAll('.checkbox');
        const formWizard = document.querySelector('form.webform-submission-configuratore-form');
        const articles = document.querySelectorAll('article');
        const sections = document.querySelectorAll('section');
        const images = document.querySelectorAll('img');
        const documentCards = document.querySelectorAll('.document-card');
        const CAROUSEL_CARD_TITLE_SELECTOR = '.field--name-field-title';
        const CAROUSEL_CARD_ANCHOR_LABEL_SELECTOR = '.button-group .screenreader-label';
        const CAROUSEL_CARD_ANCHOR_SELECTOR = '.button-group a';
        const WEBFORM_STEP_SCOPE = 'ambito';
        const WEBFORM_STEP_COMPONENTS = 'componenti';
        const WEBFORM_STEP_PROFILE = 'profilo';
        const WEBFORM_STEP_RECAP = 'recap';
        const MEDIA_BREAKPOINT_LG = 992;
        const DOCUMENT_CARD_DOWNLOAD_BLOCK_SELECTOR = '.document-card--download-block';
        function screenReaderAnchorLabel() {
            carouselCardsNodes.forEach(card => {
                const titleNode = card.querySelector(CAROUSEL_CARD_TITLE_SELECTOR).firstChild;
                const title = titleNode.innerHTML;
                const screenreaderLabel = card.querySelector(CAROUSEL_CARD_ANCHOR_LABEL_SELECTOR);
                const anchor = card.querySelector(CAROUSEL_CARD_ANCHOR_SELECTOR);
                if (anchor) {
                    screenreaderLabel.innerHTML = anchor.innerText + ' ' + title;
                }
            });
        }
        function checkboxAttributes() {
            checkboxNodes.forEach(checkbox => {
                if (!checkbox.parentElement.classList.contains('form-item-checkbox-first-step-a-lotto1') && !checkbox.parentElement.classList.contains('form-item-checkbox-first-step-a-lotto2')) {
                    const checkboxInput = checkbox.querySelector('input');
                    checkbox.addEventListener('click', (event) => {
                        checkbox.setAttribute('aria-checked', String(checkboxInput.checked));
                    });
                }
            });
        }
        function addAriaLabelledByArticleSection(elements, type) {
            elements.forEach((element, index) => {
                let checkFirstElement = 0;
                let headingTextArray = [];
                let elementId = type + "-" + index;
                element.setAttribute('aria-labelledby', elementId);
                for (let i = 1; i <= 6; i++) {
                    headingTextArray[i] = "h" + i;
                }
                headingTextArray.forEach((hText) => {
                    if (checkFirstElement) {
                        return;
                    }
                    let allHTexts = element.querySelectorAll(hText);
                    if (allHTexts.length > 0) {
                        let headingText = element.querySelector(hText);
                        headingText.setAttribute('id', elementId);
                        checkFirstElement = 1;
                    }
                });
            });
        }
        function addFormDetails() {
            const webformSteps = [WEBFORM_STEP_SCOPE, WEBFORM_STEP_COMPONENTS, WEBFORM_STEP_PROFILE, WEBFORM_STEP_RECAP];
            webformSteps.forEach((step) => {
                if (formWizard.classList.contains(step)) {
                    let selector = "[data-webform-page=" + step + "]";
                    let liSelector = formWizard.querySelector(selector);
                    let number = liSelector.querySelector("div[data-webform-progress-step]").getAttribute('data-text');
                    let title = liSelector.getAttribute('title');
                    let attribute = (number + "-" + title).toLowerCase();
                    formWizard.setAttribute('aria-labelledby', attribute);
                }
            });
        }
        function setAltAttributeImages() {
            images === null || images === void 0 ? void 0 : images.forEach(image => {
                if (!image.hasAttribute("alt") || image.getAttribute("alt") == "") {
                    image.setAttribute("alt", "");
                }
            });
        }
        function setDocumentCardDownloadFocus() {
            const tabIndexValue = window.innerWidth >= MEDIA_BREAKPOINT_LG ?
                "-1" :
                "0";
            documentCards === null || documentCards === void 0 ? void 0 : documentCards.forEach(card => {
                card.querySelector(DOCUMENT_CARD_DOWNLOAD_BLOCK_SELECTOR).setAttribute('tabindex', tabIndexValue);
            });
        }
        function init() {
            if (Boolean(carouselCardsWrapperNode)) {
                screenReaderAnchorLabel();
            }
            if (Boolean(checkboxNodes)) {
                checkboxAttributes();
            }
            if (Boolean(formWizard)) {
                addFormDetails();
            }
            addAriaLabelledByArticleSection(sections, "sections");
            addAriaLabelledByArticleSection(articles, "articles");
            setAltAttributeImages();
            setDocumentCardDownloadFocus();
        }
        init();
    });
})(Accessibility || (Accessibility = {}));
